import React, { Component } from "react";
import { cmsAccount, jsonHeaders } from "../components/NavMenu";
import { Box, Divider, List, ListItemButton, ListItemText } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./css/Group.css";
import { flushSync } from "react-dom";

export class Group extends Component {
    constructor(props) {
        super(props);

        this.state = {
            groups: [],
            devices: [],
            selectedIndex: 0,
            isDragging: false,
            dragEndSelected: null,
        };
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                this.fetchGroups();
                clearInterval(intervalId);
            }
        }, 100);
    }

    fetchGroups() {
        const { selectedIndex } = this.state;
        var requestOptions = {
            method: "GET",
            headers: jsonHeaders,
            redirect: "follow",
        };

        fetch("/api/groups", requestOptions)
            .then((res) => res.json())
            .then((result) => {
                flushSync(() => {
                    this.setState({ groups: result });
                });
                if (selectedIndex) this.selectGroup(selectedIndex);
            });
    }

    selectGroup(index) {
        this.setState({ selectedIndex: index });
        const { groups } = this.state;
        const groupId = index == 0 ? "Ungrouped" : groups[index - 1].uuid;

        var requestOptions = {
            method: "GET",
            headers: jsonHeaders,
            redirect: "follow",
        };
        fetch(`/api/groups/${groupId}/devices`, requestOptions)
            .then((res) => {
                if (res.ok) return res.json();
            })
            .then((result) => {
                if (result) this.setState({ devices: result });
            });
    }

    changeGroup(deviceId, groupId) {
        const { selectedIndex } = this.state;
        var requestOptions = {
            method: "PATCH",
            headers: jsonHeaders,
            redirect: "follow",
        };
        fetch(`/api/devices/${deviceId}?groupId=${groupId}`, requestOptions)
            .then((res) => res.json())
            .then((result) => {
                this.selectGroup(selectedIndex);
            });
    }

    removeGroup(deviceId) {
        const { selectedIndex } = this.state;
        var requestOptions = {
            method: "PATCH",
            headers: jsonHeaders,
            redirect: "follow",
        };
        fetch(`/api/devices/${deviceId}?groupId=Ungrouped`, requestOptions)
            .then((res) => res.json())
            .then((result) => {
                console.log(result);
                this.selectGroup(selectedIndex);
            });
    }

    createGroup() {
        const newGroupName = prompt("Enter new group's name");
        if (newGroupName) {
            var requestOptions = {
                method: "POST",
                headers: jsonHeaders,
                body: JSON.stringify({ name: newGroupName }),
                redirect: "follow",
            };
            fetch(`/api/groups/`, requestOptions)
                .then((res) => res.json())
                .then((result) => {
                    console.log(result);
                    this.fetchGroups();
                });
        }
    }

    renameGroup(index) {
        const { groups } = this.state;
        const groupId = groups[index - 1].uuid;
        const newGroupName = window.prompt("Edit group's name:");
        if (newGroupName) {
            var requestOptions = {
                method: "PUT",
                headers: jsonHeaders,
                body: JSON.stringify({ name: newGroupName }),
                redirect: "follow",
            };
            fetch(`/api/groups/${groupId}`, requestOptions)
                .then((res) => res.json())
                .then((result) => {
                    console.log(result);
                    this.fetchGroups();
                    this.setState({ selectedIndex: 0 });
                });
        }
    }

    deleteGroup(index) {
        if (!window.confirm("Are you sure to delete this group?")) {
            return;
        }
        const { groups } = this.state;
        const groupId = groups[index - 1].uuid;
        var requestOptions = {
            method: "DELETE",
            headers: jsonHeaders,
            redirect: "follow",
        };
        fetch(`/api/groups/${groupId}`, requestOptions)
            .then((res) => res.json())
            .then((result) => {
                console.log(result);
                this.fetchGroups();
            });
    }
    onDragStart(event) {
        this.setState({ isDragging: true });
    }
    onDragEnd(event) {
        console.log(event);
        this.setState({ isDragging: false });
        const { source } = event;
        const { groups, dragEndSelected, devices } = this.state;

        if (dragEndSelected == null) return;

        const sourceDevice = devices[source.index];
        const groupId = dragEndSelected == 0 ? "Ungrouped" : groups[dragEndSelected - 1].uuid;

        this.changeGroup(sourceDevice.uuid, groupId);
    }

    render() {
        const { groups, devices, selectedIndex, isDragging } = this.state;
        return (
            <>
                <DragDropContext onDragEnd={(e) => this.onDragEnd(e)} onDragStart={(e) => this.onDragStart(e)}>
                    <Box sx={{ width: "100%", maxWidth: 200, bgcolor: "#fbfbfb", marginLeft: "100px" }}>
                        <div className="d-flex justify-content-center my-1">
                            <button
                                className="btn btn-primary w-100 d-flex justify-content-center align-items-center gap-2"
                                onClick={() => {
                                    this.createGroup();
                                }}
                            >
                                <img src="icons/add-white.svg" width={20} />
                                Create group
                            </button>
                        </div>
                        <List component="nav" aria-label="secondary mailbox folder">
                            <div>
                                <ListItemButton
                                    className={selectedIndex === 0 ? "bg-primary text-white" : ""}
                                    selected={selectedIndex === 0}
                                    onClick={() => this.selectGroup(0)}
                                    onMouseOver={(e) => {
                                        if (isDragging) {
                                            e.currentTarget.classList.add("rounded");
                                            e.currentTarget.classList.add("rounded-2");
                                            e.currentTarget.classList.add("border");
                                            e.currentTarget.classList.add("border-2");
                                            e.currentTarget.classList.add("border-primary");
                                            this.setState({ dragEndSelected: 0 });
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.classList.remove("rounded");
                                        e.currentTarget.classList.remove("rounded-2");
                                        e.currentTarget.classList.remove("border");
                                        this.setState({ dragEndSelected: null });
                                    }}
                                >
                                    <ListItemText primary="Ungrouped" />
                                </ListItemButton>
                            </div>
                            {groups.map((group, index) => {
                                index += 1;
                                return (
                                    <div>
                                        <ListItemButton
                                            key={group.id}
                                            className={selectedIndex === index ? "bg-primary text-white" : ""}
                                            selected={selectedIndex === index}
                                            onClick={() => this.selectGroup(index)}
                                            onMouseOver={(e) => {
                                                if (isDragging) {
                                                    e.currentTarget.classList.add("rounded");
                                                    e.currentTarget.classList.add("rounded-2");
                                                    e.currentTarget.classList.add("border");
                                                    e.currentTarget.classList.add("border-2");
                                                    e.currentTarget.classList.add("border-primary");
                                                    this.setState({ dragEndSelected: index });
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.classList.remove("rounded");
                                                e.currentTarget.classList.remove("rounded-2");
                                                e.currentTarget.classList.remove("border");
                                                this.setState({ dragEndSelected: null });
                                            }}
                                        >
                                            <ListItemText primary={group.name} className="text-nowrap" />
                                        </ListItemButton>
                                    </div>
                                );
                            })}
                        </List>
                    </Box>
                    <div className="container outfit" style={{ overflowY: "scroll" }}>
                        <div className=" p-3  d-flex align-items-center justify-content-between">
                            Devices ({devices.length})
                            {selectedIndex == 0 ? (
                                <></>
                            ) : (
                                <div className="btn-group">
                                    <button
                                        className="btn btn-primary gap-1 d-flex"
                                        onClick={() => {
                                            this.renameGroup(selectedIndex);
                                        }}
                                    >
                                        <i className="bi bi-pencil" />
                                        Edit name
                                    </button>
                                    <button
                                        className="btn btn-danger gap-1 d-flex"
                                        onClick={() => {
                                            this.deleteGroup(selectedIndex);
                                        }}
                                    >
                                        <i className="bi bi-trash" />
                                        Delete group
                                    </button>
                                </div>
                            )}
                        </div>
                        <Divider />
                        <Droppable droppableId="device-list" direction="horizontal">
                            {(provided, snapshot) => (
                                <div
                                    className="row row-cols-5 p-3"
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={{ overflow: "hidden" }}
                                >
                                    {devices.map((device, index) => {
                                        return (
                                            <>
                                                <Draggable draggableId={device.uuid} index={index} key={device.uuid}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            className="col p-3"
                                                            key={device.id}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <div
                                                                className="card d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    height: "100px",
                                                                    boxShadow: "0px 4px 8px 2px rgb(0,0,0,0.25)",
                                                                    background: snapshot.isDragging
                                                                        ? "rgba(0, 0, 0, 0.1)"
                                                                        : "white",
                                                                    opacity: snapshot.isDragging ? 0.5 : 1,
                                                                    width: "170px",
                                                                    userSelect: "none",
                                                                }}
                                                            >
                                                                {device.name}
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            </>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                </DragDropContext>
            </>
        );
    }
}
